import React from 'react';
import { UtilityCard } from '@uk-source-web/utility-card';
import { SWUtilityCardProps } from './SWUtilityCard.types';
import { renderToString } from 'react-dom/server';
import { documentToReactComponents } from '@contentful/rich-text-react-renderer';
import { UtilityCardContainer } from './SWUtilityCard.styles';

const SWUtilityCard = ({
  heading,
  bodyText,
  iconName,
  linkWithIcon,
  elevation,
  orientation,
  verticalAlign,
  labelText,
  labelAppearance,
  align,
}: SWUtilityCardProps) => {
  // 1) Parse and trim the rich text JSON only once:
  const hasBody = Boolean(bodyText?.raw);
  const parsed = hasBody ? JSON.parse(bodyText.raw) : undefined;
  const trimmed = parsed ? { ...parsed, content: parsed.content[0].content } : undefined;

  // 2) Pre‑render the rich text if present:
  const renderedText = trimmed ? renderToString(documentToReactComponents(trimmed)) : undefined;

  // 3) Default props:
  const finalHeading = heading ?? '';
  const finalIcon = { name: iconName ?? 'info-circle' };
  const finalElev = elevation ?? false;
  const finalOrient = orientation ?? 'vertical';
  const finalVAlign = verticalAlign ?? 'fill';

  // 4) Build linkWithIcon prop if present:
  const linkProps = linkWithIcon
    ? {
        text: linkWithIcon.text ?? '',
        icon: {
          name: linkWithIcon.icon ?? 'arrow-right',
          justify: 'right' as const,
        },
        href: linkWithIcon.url!,
      }
    : undefined;

  // 5) Build label prop if present:
  const labelProps = labelText
    ? {
        text: labelText,
        appearance: labelAppearance ?? ('primary' as const),
      }
    : undefined;

  // Final render with a flat prop list:
  return (
    <UtilityCardContainer align={align}>
      <UtilityCard
        appearance="primary"
        heading={{ text: finalHeading }}
        text={renderedText}
        icon={finalIcon}
        elevation={finalElev}
        orientation={finalOrient}
        linkWithIcon={linkProps}
        verticalAlign={finalVAlign}
        label={labelProps}
      />
    </UtilityCardContainer>
  );
};

export default SWUtilityCard;
